import styled from 'styled-components';

interface Props {
  isSelected: boolean;
  isFocused: boolean;
  isDisabled: boolean;
}

export const StyledOption = styled('li')<Props>`
  outline: none;
  cursor: pointer;
  white-space: nowrap;

  padding: ${({ theme }) => theme.x1}px;
  background-color: ${({ theme, isSelected, isFocused }) => {
    if (isSelected) return theme.color.brand01RGBA(0.1);
    if (isFocused) return theme.color.paper;
    return 'transparent';
  }};
  color: ${({ theme, isDisabled }) => {
    if (isDisabled) return theme.color.textSofter;
    return theme.color.black;
  }};
`;
